export enum SignalEventType {
  changeNotificationCount = 'changeNotificationCount',
  newRequestUpdate = 'newRequestUpdate',
  changePromotionStepStatus = 'changePromotionStepStatus',
  changePromotionStatus = 'changePromotionStatus',
  changeDotNetPromotionStepStatus = 'changeDotNetPromotionStepStatus'
}

export interface SignalEvent<TDataShape> {
  type: SignalEventType,
  data: TDataShape
}
